/* チェックボックス */
import React, { memo } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
var CheckBox = function (_a) {
    var id = _a.id, class_name = _a.class_name, value = _a.value, name = _a.name, handleChange = _a.handleChange, sources = _a.sources, disabled = _a.disabled;
    return (React.createElement(InputGroup, { className: class_name }, sources.map(function (src, index) {
        return (React.createElement("label", { key: src.key },
            React.createElement(Form.Check, { id: id + "-" + index, className: "check-box", type: "checkbox", inline: true, value: src.key, name: name, checked: value.includes(src.key), onChange: handleChange, disabled: disabled || false }),
            src.value));
    })));
};
export default memo(CheckBox);
